import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const RetailersSelector = props => {
    const allOption = props.localizedOfferPrefs.retailers.reduce((result, retailer) => {
        result.value.push(retailer.id);
        return result;
    }, {value: [], label: 'All'});
    const options = props.localizedOfferPrefs.retailers.map(elem => (
        {value: elem.id, label: elem.name}
    ));
    options.unshift(allOption);
    const defaultValue = props.localizedOfferPrefs.retailers.reduce((values, elem) => {
       if (props.newOffer.retailerIds.includes(elem.id)) {
            values.push({
                value: elem.id,
                label: elem.name
            });
       }
        return values;
    }, []);
    return (
        <React.Fragment>
            <Select
                name={props.name}
                closeMenuOnSelect={true}
                value={defaultValue}
                isMulti
                options={options}
                required={props.required}
                onChange={data => {
                    props.onRetailersItemChange(data);
                }}
                styles={{
                    control: (styles, { data, isSelected }) => ({
                        ...styles,
                        color: '#3e5569',
                        backgroundColor: 'white',
                        borderColor: '#e9ecef'
                    }),
                    singleValue: (styles, { data }) => ({
                        ...styles,
                        color: '#3e5569'
                    }),
                }}
            />
            {!props.disabled && (
                <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, position: 'absolute' }}
                    defaultValue={defaultValue}
                    required={props.required}
                />
            )}
        </React.Fragment>
    )
};

RetailersSelector.propTypes = {
    name: PropTypes.string,
    localizedOfferPrefs: PropTypes.object,
    newOffer: PropTypes.object,
    onRetailersItemChange: PropTypes.func
};

export default RetailersSelector;


// WEBPACK FOOTER //
// ./src/components/Promo/Offer/RetailersSelector.js